export const MODE_COMPARE = "compare";
export const MODE_DETAIL = "detail";

export default class PackageComparingModal {
  constructor(options = {}) {
    ({
      mode: this.mode,
      href: this.href,
      packageIds: this.packageIds
    } = options);
  }

  openModal() {
    const packageIds = this.getPackageIds();

    const originalUrl = new URL(this.getHref(), document.location);
    originalUrl.searchParams.set('mode', this.getMode());
    originalUrl.searchParams.set('packageIds', packageIds.join(','));

    const url = originalUrl.toString();
    jQuery.fancybox({
      href: url,
      hideOnContentClick: false,
      hideOnOverlayClick: true,
      transitionIn: 'none',
      transitionOut: 'none',
      overlayShow: true,
      overlayOpacity: 0.9,
      overlayColor: '##474540',
      image: false,
      titleShow: false,
      padding: 0,
      margin: 0,
      width: this.getMode() === MODE_DETAIL ? '670px' : '90%',
      height: '90%',
      scrolling: 'yes',
      onComplete: () => {
        this.setupProductTooltips();
        this.setupComparisonBars();
      },
      onStart: () => {
        jQuery("body").css({ 'overflow': 'hidden' });
        if (jQuery("#fancybox-wrap").parent('.fancybox-wrap-no-scroll').length <= 0) {
          jQuery("#fancybox-wrap").wrap("<div class='fancybox-wrap-no-scroll'></div>");
        }
        jQuery('#fancybox-close').append('<span class="fa fa-times fa-lg"></span>');
      },
      onClosed: () => {
        if (jQuery("#fancybox-wrap").parent('.fancybox-wrap-no-scroll').length) {
          jQuery("#fancybox-wrap").unwrap();
        }
        jQuery("body").css({ 'overflow': '' });
      },
    });
  }

  getMode() {
    return this.mode;
  }

  getHref() {
    return this.href;
  }

  getPackageIds() {
    return this.packageIds;
  }

  setupProductTooltips() {
    const is_touch_device =
      ('ontouchstart' in window) ||
      (navigator.MaxTouchPoints > 0) ||
      (navigator.msMaxTouchPoints > 0);

    const activation = is_touch_device ? "click" : "hover";

    jQuery('.package-compare .product-container').cluetip({
      cluezIndex: 10000,
      width: 400,
      showTitle: false,
      sticky: false,
      attribute: 'data-tip',
      arrows: true,
      positionBy: 'auto',
      hoverClass: 'tooltip-invoker',
      activation: activation,
      cluetipClass: 'jtip'
    });
  }

  setupComparisonBars() {
    if (window.packageCalculator) {
      window.packageCalculator.populateBarIndicatorsInCompareModal();
    }
  }
}
